/** @jsx h */
import { h, hydrate } from 'preact';
import DraftOrder from '../components/DraftOrder';

function initPreactDraftOrder() {
  const mountPoint = document.getElementById('preact-draft-order');

  if (!mountPoint) return;

  hydrate(<DraftOrder />, mountPoint);
}

document.addEventListener('DOMContentLoaded', initPreactDraftOrder);
